
import progressBg from "../../assets/actionPlan/ic_progress_bg.png";
import "./ActionPlanProgress.scss";
import React, { useEffect, useRef } from "react";

const ActionPlanProgress = ({ value = 90, showPercentage = false, stroke = 14 }) => {
  const ringRef = useRef(null);
  const radius = 76;
  const CIRC = 2 * Math.PI * radius;
  const GAP = 14;

  useEffect(() => {
    const ring = ringRef.current;
    if (!ring) return;

    let animated = false;

    const animateRing = () => {
      if (animated) return;
      animated = true;

      const bar = ring.querySelector(".bar");
      const track = ring.querySelector(".track");

      const targetLen = (value / 100) * CIRC;

      const isEdge = value <= 0;
      const effectiveGap = isEdge ? 0 : GAP;

      const barLen = Math.max(0, targetLen - 2 * effectiveGap);
      const trackLen = Math.max(0, CIRC - targetLen - 2 * effectiveGap);

      // Track
      track.style.strokeDasharray = `${trackLen} ${CIRC}`;
      track.style.strokeDashoffset = `${-(targetLen + effectiveGap)}`;

      // Bar animation
      bar.style.strokeDashoffset = `${-effectiveGap}`;
      bar.style.strokeDasharray = `0 ${CIRC}`;

      requestAnimationFrame(() => {
        bar.style.strokeDasharray = `${barLen} ${CIRC}`;
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) animateRing();
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(ring);

    return () => observer.disconnect();
  }, [value, CIRC]);

  return (
    <div className="perf-ring" ref={ringRef}>
      <svg
        viewBox="0 0 180 180"
        style={{ transform: "rotate(-90deg)" }}
      >
        <circle
          className="track"
          cx="90"
          cy="90"
          r={radius}
          stroke="rgba(7,211,196,0.4)"
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
        />

        <circle
          className="bar"
          cx="90"
          cy="90"
          r={radius}
          stroke="#07D3C4"
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          style={{
            strokeWidth: value === 0 ? 0:stroke,
            transition:
              "stroke-dasharray 1.8s cubic-bezier(0.22, 0.61, 0.36, 1)",
          }}
        />
      </svg>

      {/* Center Value */}
      <div
        className="perf-num-val"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        
        {showPercentage ? (
          <span className="perf-num-val__text">{value}%</span>
        ):<img src={progressBg} alt="progress-bg" width={95} height={95}/>}
      </div>
    </div>
  );
};

export default ActionPlanProgress;
